// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';
import Delivery from '../../deliveryTime';

const DeliveryTime = styled<typeof Delivery, Theme, _>(Delivery)`
  margin-bottom: 0;
`;

export default DeliveryTime;
